__turbopack_context__.v({
  "sponsor_link": "ksO7qa_sponsor_link",
  "sponsor_logo": "ksO7qa_sponsor_logo",
  "sponsor_logos": "ksO7qa_sponsor_logos",
  "sponsorship_logos_intro": "ksO7qa_sponsorship_logos_intro",
  "sponsorship_logos_wrapper": "ksO7qa_sponsorship_logos_wrapper",
});
